module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "",
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('硬件编码')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.devHdcode),
      expression: "devHdcode"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.devHdcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.devHdcode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.getLangText('接收客户')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custName),
      expression: "custName"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.custName)
    },
    on: {
      "change": _vm.onCustNameChage,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "width": "240px",
      "height": "20px",
      "margin-top": "-10px",
      "margin-left": "180px",
      "border": "0px solid red",
      "color": "#eb5757"
    }
  }, [_vm._v(_vm._s(_vm.custId))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "40px",
      "border": "0px solid red",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "16px",
      "margin-left": "50px"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("取消")))]), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "16px",
      "margin-right": "50px",
      "float": "right"
    },
    on: {
      "click": _vm.onOKClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("确定")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fd0c8f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/devDevo.vue
// module id = 757
// module chunks = 1